const ERROR_LOG_PATH = '/api/v1/ardhisasa/errors/log';

const log = (type, message, context = {}) => {
  try {
    window.axios
      ?.post(ERROR_LOG_PATH, {
        type,
        message: String(message).slice(0, 500),
        context,
        url: window.location.href,
      })
      .catch(() => {});
  } catch {
    // logging must never break the app
  }
};

export const logArdhisasaApiError = (endpoint, status, body) =>
  log('ardhisasa_api_error', `${endpoint} failed with ${status}`, {
    endpoint,
    status,
    response: String(body).slice(0, 300),
  });

export const logVueError = (error, instance, info) =>
  log('unhandled_exception', error?.message || String(error), {
    stack: error?.stack?.slice(0, 500),
    component: instance?.$options?.name,
    info,
  });

export const logUnhandledRejection = reason =>
  log('unhandled_exception', reason?.message || String(reason), {
    stack: reason?.stack?.slice(0, 500),
    type: 'unhandled_promise_rejection',
  });
